import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Action, PageBody } from '../../components/aa';
import { BILLING_VIEW_KEY } from '../../components/settings/BillingPanel';
import { PROJECTS_BILLING_VIEW, ProjectBudgetDetailView } from '../../components/settings/ProjectBudgetsPanel';

/* Back to Billing's Project budgets tab, which lives in Settings. */
const openProjectBudgets = () => {
  try {
    sessionStorage.setItem(BILLING_VIEW_KEY, PROJECTS_BILLING_VIEW);
  } catch {
    /* storage blocked: Billing opens on its first tab */
  }
  window.dispatchEvent(new CustomEvent('settings:open', { detail: { section: 'payment' } }));
};

/* A provider Owner's view of one client project's budget. */
export const ProviderProjectBudgetPage: React.FC = () => {
  const { clientId = '', projectId = '' } = useParams();
  if (!localStorage.getItem('provider_id')) return <Navigate to="/dashboard" replace />;
  const back = (
    <Action variant="ghost" size="sm" icon={<ArrowLeft size={14} />} to={`/clients/${clientId}?tab=budgets`} className="mb-4">
      Back to project budgets
    </Action>
  );
  return (
    <PageBody>
      <ProjectBudgetDetailView side={{ kind: 'provider', clientId }} projectId={projectId} back={back} />
    </PageBody>
  );
};

/* The client Owner's view of one of its project budgets. */
export const OwnerProjectBudgetPage: React.FC = () => {
  const { projectId = '' } = useParams();
  const back = (
    <Action variant="ghost" size="sm" icon={<ArrowLeft size={14} />} onClick={openProjectBudgets} className="mb-4">
      Back to project budgets
    </Action>
  );
  return (
    <PageBody>
      <ProjectBudgetDetailView side={{ kind: 'client' }} projectId={projectId} back={back} />
    </PageBody>
  );
};
